import { HueValue } from "@app/app-libs/material-css-vars/material-css-vars.model";
import { Adapter } from "@app/shared/models/adapter.model";
import { ContextMenuSettings, InputSettings, NotificationSettings, TooltipSettings } from "@app/shared/models/portal-settings.model";

export interface ViewerSettings {
  canPrint: boolean;
  canDownload: boolean;
  canSearch: boolean;
  hasContextMenu: boolean;
  printResolution: number;
  viewerMagnification: string;
  viewOnlyAnnotations: boolean;
  enableAnnotations: boolean;
  autoSaveAnnotations: boolean;
  promptOnDeleteAnnotations: boolean;
  viewDocumentInWindow: boolean;
  viewDocumentReplaceWindow: boolean;
}

export interface SideNavSettings {
  setSideNavToCollapsed: boolean;
}

export interface FavoritesSettings {
  showFavoritesTabs: boolean;
}

export interface ReportSettings {
  canViewAllUsersReports: boolean;
  hasReportNotificaton: boolean;
}

export interface InBasketSettings {
  hasInbasket: boolean;
  canViewAllUsersInBasket: boolean;
  canDeleteInBasketItems: boolean;
  autoDeleteInBasketItems: boolean;
  isDescrAutoPopulate: boolean;
}

export interface TabSettings {
  defaultTab: string;
}

export interface OndemandSettings {
  canOnDemandExecute: boolean;
  canOnDemandMaintain: boolean;
  canOnDemandDelete: boolean;
  canOnDemandDownload: boolean;
}

export interface TableSettings {
  tablePageSize: number;
  tableShowFirstLastButtons: boolean;
}

export interface ThemeSettings {
  primaryColor: string;
  accentColor: string;
  warningColor: string;
  isDarkTheme: boolean;
  isAutoContrast: boolean;
  contrastColorThresholdPrimary: HueValue;
  contrastColorThresholdAccent: HueValue;
  contrastColorThresholdWarn: HueValue;
  iconAppearance: string;
  colorWorkspaceLight: string;
  colorWorkspaceDark: string;
  colorPrimaryButton: string;
}

export interface RecentActivitySettings {
  recentActivityReports: boolean;
  recentActivityOnDemand: boolean;
  recentActivityMenuItems: boolean;
  recentActivityFavorites: boolean;
  recentActivityMaxItems: number;
}

export class UserSettings {
  public themeSettings: ThemeSettings;
  public language: string;
  public viewerSettings: ViewerSettings;
  public sideNavSettings: SideNavSettings;
  public favoritesSettings: FavoritesSettings;
  public reportSettings: ReportSettings;
  public tabSettings: TabSettings;
  public ondemandSettings: OndemandSettings;
  public tableSettings: TableSettings;
  public inputSettings: InputSettings;
  public notificationSettings: NotificationSettings;
  public tooltipSettings: TooltipSettings;
  public contextMenuSettings: ContextMenuSettings;
  public inbasketSettings: InBasketSettings;
  public recentActivity: RecentActivitySettings;
  public isTipsAndHintsEnabled: boolean;
  public isActive: boolean;

  constructor(userSettings: UserSettings) {
    this.themeSettings = userSettings.themeSettings;
    this.language = userSettings.language;
    this.viewerSettings = userSettings.viewerSettings;
    this.sideNavSettings = userSettings.sideNavSettings;
    this.favoritesSettings = userSettings.favoritesSettings;
    this.reportSettings = userSettings.reportSettings;
    this.tabSettings = userSettings.tabSettings;
    this.ondemandSettings = userSettings.ondemandSettings;
    this.tableSettings = userSettings.tableSettings;
    this.inputSettings = userSettings.inputSettings;
    this.notificationSettings = userSettings.notificationSettings;
    this.tooltipSettings = userSettings.tooltipSettings;
    this.contextMenuSettings = userSettings.contextMenuSettings;
    this.inbasketSettings = userSettings.inbasketSettings;
    this.recentActivity = userSettings?.recentActivity;
    this.isTipsAndHintsEnabled = userSettings?.isTipsAndHintsEnabled;
    this.isActive = userSettings?.isActive;
  }
}

export class UserSettingsAdapter implements Adapter<UserSettings> {
  adapt(rawData: UserSettings): UserSettings {
    if (!rawData) {
      return null;
    }

    return new UserSettings(rawData);
  }
}
